import type { TimePickerPeriod } from './TimePicker.types'

export const TIME_PICKER_HOURS = Array.from({ length: 12 }, (_, index) =>
  String(index + 1).padStart(2, '0'),
)

export const TIME_PICKER_MINUTES = Array.from({ length: 60 }, (_, index) =>
  String(index).padStart(2, '0'),
)

export const TIME_PICKER_PERIODS: TimePickerPeriod[] = ['AM', 'PM']

export type TimePickerParts = {
  hours: string
  minutes: string
  period: TimePickerPeriod
}

export const getTimePickerParts = (date: Date): TimePickerParts => {
  const hours24 = date.getHours()
  const period: TimePickerPeriod = hours24 >= 12 ? 'PM' : 'AM'
  let hours12 = hours24 % 12

  if (hours12 === 0) {
    hours12 = 12
  }

  return {
    hours: String(hours12).padStart(2, '0'),
    minutes: String(date.getMinutes()).padStart(2, '0'),
    period,
  }
}

export const formatTimePickerValue = (date: Date): string => {
  const { hours, minutes, period } = getTimePickerParts(date)
  return `${hours} : ${minutes} ${period}`
}

export const buildTimePickerDate = (
  hours: string,
  minutes: string,
  period: TimePickerPeriod,
  baseDate = new Date(),
): Date => {
  let hour = Number.parseInt(hours, 10)

  if (period === 'AM') {
    if (hour === 12) {
      hour = 0
    }
  } else if (hour !== 12) {
    hour += 12
  }

  return new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    hour,
    Number.parseInt(minutes, 10),
    0,
    0,
  )
}

export const parseTimePickerValue = (value: string): Date | null => {
  const match = value.trim().match(/^(\d{1,2})\s*:\s*(\d{2})\s*(AM|PM)$/i)

  if (!match) {
    return null
  }

  const hours = Number.parseInt(match[1], 10)
  const minutes = Number.parseInt(match[2], 10)
  const period = match[3].toUpperCase() as TimePickerPeriod

  if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59) {
    return null
  }

  return buildTimePickerDate(
    String(hours).padStart(2, '0'),
    String(minutes).padStart(2, '0'),
    period,
  )
}
